exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".arrow-link[data-v-1fb5a114]{font-size:12px;font-size:.75rem}.arrow-link:hover span[data-v-1fb5a114]{text-decoration:underline}.arrow-link-icon[data-v-1fb5a114]{flex-shrink:0}", ""]);

